import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useNotificationCounts } from '../../lib/notifications/hooks/useNotificationCounts';
import { NotificationList } from './NotificationList';

type TabId = 'booking' | 'other';

interface Tab {
  id: TabId;
  label: string;
  count?: number;
  entityType: string;
}

export const NotificationTabs = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState<TabId>('booking');
  const { counts, loading } = useNotificationCounts();

  const tabs: Tab[] = [
    { 
      id: 'booking', 
      label: t('bookings'), 
      count: counts.booking,
      entityType: 'booking'
    },
    { 
      id: 'other', 
      label: t('other'), 
      count: counts.other,
      entityType: 'other'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg h-full flex flex-col">
      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="flex px-6" aria-label="Notifications">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                flex-1 py-4 px-1 inline-flex items-center justify-center border-b-2 font-medium text-sm
                ${activeTab === tab.id
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              <span className="relative">
                {tab.label}
                {tab.count !== undefined && tab.count > 0 && (
                  <span className={`
                    absolute -top-2 -right-6 px-2 py-0.5 rounded-full text-xs font-medium
                    ${activeTab === tab.id
                      ? 'bg-primary-100 text-primary-600'
                      : 'bg-gray-100 text-gray-900'
                    }
                  `}>
                    {tab.count}
                  </span>
                )}
              </span>
            </button>
          ))}
        </nav>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        {loading ? (
          <div className="flex justify-center items-center h-32">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
          </div>
        ) : (
          <NotificationList entityType={tabs.find(t => t.id === activeTab)?.entityType} />
        )}
      </div>
    </div>
  );
}; 